(() => {
  const storageKey = 'ferry:campaign-attribution:v1';
  const maximumValueLength = 160;
  const campaignParameters = {
    utm_source: 'source',
    utm_medium: 'medium',
    utm_campaign: 'campaign',
    utm_content: 'content',
    utm_term: 'term',
  };
  const attributionKeys = [
    'source',
    'medium',
    'campaign',
    'content',
    'term',
    'landingPath',
    'referrerHost',
    'sourceEvidence',
  ];

  const cleanValue = (value) => {
    if (typeof value !== 'string') return '';
    return value.trim().slice(0, maximumValueLength);
  };

  const sanitizeAttribution = (value) => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;

    const sanitized = {};
    attributionKeys.forEach((key) => {
      sanitized[key] = cleanValue(value[key]);
    });

    return sanitized.source ? sanitized : null;
  };

  const readStoredAttribution = () => {
    try {
      return sanitizeAttribution(JSON.parse(window.sessionStorage.getItem(storageKey)));
    } catch (_error) {
      return null;
    }
  };

  const writeStoredAttribution = (attribution) => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (_error) {
      // Attribution is helpful context, but it must never block the native form.
    }
  };

  const currentUrl = new URL(window.location.href);
  const currentCampaign = {};
  let hasCampaignParameter = false;

  Object.entries(campaignParameters).forEach(([parameter, key]) => {
    const value = cleanValue(currentUrl.searchParams.get(parameter));
    currentCampaign[key] = value;
    hasCampaignParameter = hasCampaignParameter || Boolean(value);
  });

  let referrerHost = '';
  if (document.referrer) {
    try {
      const referrerUrl = new URL(document.referrer);
      if (referrerUrl.origin !== currentUrl.origin) {
        referrerHost = cleanValue(referrerUrl.hostname);
      }
    } catch (_error) {
      referrerHost = '';
    }
  }

  const currentAttribution = sanitizeAttribution({
    ...currentCampaign,
    source: currentCampaign.source || referrerHost || 'direct',
    medium: currentCampaign.medium || (referrerHost ? 'referral' : 'none'),
    landingPath: currentUrl.pathname,
    referrerHost,
    sourceEvidence: currentCampaign.source ? 'utm_source' : referrerHost ? 'referrer' : 'unobserved',
  });
  const storedAttribution = readStoredAttribution();
  const attribution = hasCampaignParameter ? currentAttribution : storedAttribution || currentAttribution;

  if (attribution && !attribution.sourceEvidence) {
    attribution.sourceEvidence = 'legacy_unknown';
  }

  if (attribution) {
    writeStoredAttribution(attribution);
  }

  document.querySelectorAll('#PartnerInquiryForm, [data-campaign-attribution-form]').forEach((form) => {
    form.querySelectorAll('[data-campaign-field]').forEach((field) => {
      const key = field.dataset.campaignField;
      field.value = attribution?.[key] || '';
    });
  });
})();
